import { render, staticRenderFns } from "./NotificationsPreferences.vue?vue&type=template&id=f7532682&"
import script from "./NotificationsPreferences.vue?vue&type=script&lang=ts&"
export * from "./NotificationsPreferences.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports